import IncomingTrafficFilter from "../../components/filters/IncomingTrafficFilter/IncomingTrafficFilter";
import IncomingTrafficFilterResult from "../../components/filters/IncomingTrafficFilter/IncomingTrafficFilterResult";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { defineDescriptionFilter } from "../defineSourcedFilter";

import FindIncomingTrafficFilter from "./IncomingTrafficFilter";

export const incomingTrafficDefinition = defineDescriptionFilter({
    key: "incomingTraffic",
    apiCategory: leadsFilterApiCategory.incomingTraffic,
    category: leadsFilterCategoryMap.trafficAndEngagement,
    trackingName: "Visits",
    titleKey: { key: "si.lead_gen_filters.group.visits.name" },

    render: ({ description }) => ({
        tooltipText: { key: "si.lead_gen_filters.group.visits.tooltip" },
        filter: new FindIncomingTrafficFilter({
            options: description.bucketsDescription.incomingTraffic,
        }),
        filterView: IncomingTrafficFilter,
        filterResultView: IncomingTrafficFilterResult,
    }),
});
